module.exports = __webpack_public_path__ + "img/card_ip_stipulation86.40dee4fc.svg";